import { Component, Input,OnInit,HostListener,ViewChild,ElementRef, NgZone} from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";

import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-student-structure-report',
  templateUrl: './student-structure-report.component.html',
  styleUrls: ['./student-structure-report.component.css'],
  providers: [TestSeriesService]
})
export class StudentStructureReportComponent implements OnInit {
  @Input() paperId;
  
  
  notfound:any;
  isPostLoad=true;
  msg:any='';
  userData:any;
  isError=false;
  siteUrl = this.global.websiteUrl;
  testAnswerUploadStructures:any;
  testPaperId = 0;
  markBox:any;
  testData:any;
  testPaperStructures:any;
  comment:any;
  percentDone = 0;

  constructor(private http:HttpClient,private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 
    this.markBox={}; 
    this.commonService.profile.subscribe((data:any)=>{
      if(data){
      this.userData=data; 
      }else{
        this.userData={};
      } 
    });
  }

  ngOnInit() {

  
    window.scrollTo(0, 0);
    this.testPaperId = (this.paperId) ? this.paperId : 0;
   console.log('initi',this.paperId);
    if(this.testPaperId){      
      let filter = {};
      filter['testPaperId'] = this.testPaperId;
      filter['studentId'] = (this.userData.id)?this.userData.id:0;
      this.getPapersMarksSummery(filter);
    }else{
      this.isPostLoad = false;
      this.notfound = true;
    }

    this.route.params.subscribe((params:Params)=>{
      if(params['id'] && this.paperId==''){   
        this.isPostLoad = true;   
        this.notfound = false;
        this.testPaperId = parseInt(params['id']);
        console.log('testPaperId',this.testPaperId);
        if(isNaN(this.testPaperId)){
          this.testPaperId=0;
        }
        let filter = {};
        filter['testPaperId'] = this.testPaperId;
        filter['studentId'] = (this.userData.id)?this.userData.id:0;
        this.getPapersMarksSummery(filter);
      }
    });
    
  }


  getPapersMarksSummery(obj){
   
    //obj['studentId']=21;
    //obj['testPaperId'] = 3;
   
    this.testseriesservice.getstudentreportlist(obj).subscribe((data:any)=>{
     let finaldata = [];
        if(data.error==0){
          this.testData= data.results;
          this.testAnswerUploadStructures = data.results.testAnswerUploadStructures;
          this.testPaperStructures =this.getNestedChildren(this.testData.testPaper.testPaperStructures,0);
          console.log(this.testPaperStructures);
         // set data
         //console.log('structure00',this.testData.testPaper.testPaperStructures);
         //console.log('structure',this.testPaperStructures);
          this.setansmark();
          this.comment=this.testData.comment;
          this.notfound = false;
          this.isError = false;
          this.isPostLoad = false;
      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
        // this.isError = true;
        }
        this.notfound = true;
        this.isPostLoad = false;
        this.testAnswerUploadStructures = [];
        this.testPaperStructures = [];
      }
    },(error : HttpErrorResponse)=>{    
      this.isPostLoad=false;  
      this.msg="internal server error!";
    });    
  }

  setansmark(){
    if(this.testAnswerUploadStructures.length>0){
      for(let keyData of this.testAnswerUploadStructures){
       this.markBox[keyData.paperStructureId] = keyData.mark;
       console.log(this.markBox);
      }

  }
  //console.log('ans',this.markBox);
  }
   getNestedChildren(arr, parent) {
    var out = []
    for(var i in arr) {
        if(arr[i].parent == parent) {
            var children = this.getNestedChildren(arr, arr[i].id)
            if(children.length) {
                arr[i].children = children
            }
            out.push(arr[i])
        }
    }
    return out
}

totalMark(objMark){
  let mark=0;
    for(let key in objMark){
            if(!isNaN(parseInt(objMark[key]))){
              mark = mark+parseInt(objMark[key]);
            }    
    }
  return mark;
}

    downloadAttachment(fileName){
        
      var downloadurl=this.global.tsAnsImageUrl+fileName;
      this.percentDone = 0;

      const req = new HttpRequest('GET', downloadurl, {
        reportProgress: true,
        responseType: 'blob'
      });

      this.http.request(req).subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            console.log('Request sent!');
            break;
          case HttpEventType.ResponseHeader:
            console.log('Response header received!');
            break;
          case HttpEventType.DownloadProgress:
            this.percentDone = Math.round(100 * event.loaded / event.total);
            console.log( this.percentDone);
            break;
          case HttpEventType.Response:
            console.log('Done!', event);
            let file = event.body;
            console.log(file.size + " bytes file downloaded. File type: ", file.type);                
            // create and download link
            var url = window.URL.createObjectURL(file);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element */

        }

      }, error => {
        if(error.status="404"){
              alert('Something went wrong. Please try to latter.');
              this.percentDone = 0;
        }
      }, () => {
        this.percentDone = 0;
      });

    }

} 



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/student-structure-report/student-structure-report.component.ts